import { Col, Row, Typography } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { GetAllPharmacies } from '../../../_config/utils/get-all-pharmacies.util';
import CustomCard from '../../../components/Antd/Card';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomLink from '../../../v2-components/Antd/Link';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import Pharmacies from '../../../v2-components/Pharmacies';
import { selectOptionsMarket } from '../constants/select-options-marketplace';
import { selectOptions } from '../constants/select-options.constant';
import { handleSearchParams } from '../handle/search-params.handle';
import { Service } from '../service';
import usePharmacyStore from './store/pharmacy-store';
import { platformNames } from '../constants/platform-names.contants';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

import './style.scss';

export default function AdminPharmacySliderTemplatesPage() {
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location?.search);
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const pharmacyQueryParam = searchParams.get('pharmacy');
	const [pharmacy, setPharmacy] = useState(pharmacyQueryParam);
	const [selectedPageType, setSelectedPageType] = useState(null);
	const [pharmacyLocations, setPharmacyLocations, setSelectedPharmacy, setPlatform, ecosystem, setEcosystem] = usePharmacyStore((state) => [
		state.pharmacyLocations,
		state.setPharmacyLocations,
		state.setSelectedPharmacy,
		state.setPlatform,
		state.ecosystem,
		state.setEcosystem,
	]);

	useEffect(() => {
		setPharmacyLocations([]);
	}, [setPharmacyLocations]);

	useEffect(() => {
		if (pharmacy) {
			setOpenLoadingModal(true);
			setSelectedPharmacy(pharmacy);
			new Service()
				.getAllTemplates(ecosystem, pharmacy)
				.then((templatesResponse) => {
					const hasTemplates = templatesResponse.length > 0;
					const isValidEcosystem = ecosystem === platformNames.ecc || (ecosystem === platformNames.mkt && selectedPageType !== null);
				
					if (hasTemplates && isValidEcosystem) {
						setPharmacyLocations(templatesResponse);
						setPlatform(templatesResponse[0].platform);
					} else {
						setPharmacyLocations([]);
						setPlatform(null);
					}
					setOpenLoadingModal(false);
				})
				.catch((error) => {
					CustomNotification({ type: 'error', description: 'Ha ocurrido un error al obtener los recursos:', message: error });
				});
		}
	}, [pharmacy, setPharmacyLocations, setSelectedPharmacy, setPlatform, ecosystem, setEcosystem, selectedPageType]);

	const handleSelectChange = (value) => {
		GetAllPharmacies(value, setPharmacy);
		searchParams.set('pharmacy', value);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
		if (value === platformNames.pharol) {
			setEcosystem(platformNames.mkt);
		} else {
			setEcosystem(platformNames.ecc);
		}
	};

	const handleSelectChangeMarket = (value) => {
		GetAllPharmacies(value, setPharmacy);
		searchParams.set('pharmacy', value);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
		setSelectedPageType(value)
	};
	return (
		<div className="admin-pharmacy-sliders-template">
			<h1>Configuración de espacios publicitarios</h1>
			<Row className='admin-pharmacy-selects-container'>
				<Typography>Plataforma</Typography>
				<Pharmacies className="custom-pharmacies" options={selectOptions[Enviroment.COUNTRY]} onChange={handleSelectChange} placeholder='Seleccionar plataforma' defaultValue={pharmacyQueryParam} />
			</Row>
			{ecosystem === platformNames.mkt && (
				<Row className='admin-pharmacy-selects-container'>
					<Typography>Tipo de página</Typography>
					<Pharmacies className="custom-pharmacies" options={selectOptionsMarket[Enviroment.COUNTRY]} onChange={handleSelectChangeMarket} placeholder='Seleccionar tipo de página' />
				</Row>
			)}
			{pharmacyLocations?.length > 0 ? (
				<>
					<h2>Seleccionar página a editar</h2>
					<Row gutter={[16, 16]}>
						{pharmacyLocations?.map((iterator, key) => {
							return (
								<Fragment key={key}>
									<Col md={8} xs={24}>
										<CustomLink className="card-link" to={`/v2/admin-pharmacy-sliders/templates/${iterator.template}`}>
											<CustomCard
												className="pharmacy-sliders-cards"
												title={
													<div className="card-header-container">
														<h3>{iterator.label}</h3>
														<div className="inner-container">
															<p>{iterator.modules.length} elementos configurables</p>
														</div>
													</div>
												}
											>
												<CustomImage preview={false} src={iterator.img_cover} alt="img" />
											</CustomCard>
										</CustomLink>
									</Col>
								</Fragment>
							);
						})}
					</Row>
				</>
			) : (
				<h2>Elija una plataforma para ver las páginas editables</h2>
			)}

			<LoadingModal visible={openLoadingModal} />
		</div>
	);
}
